module.exports = __webpack_public_path__ + "static/media/dry_weather.c1368c22.jpg";